
/* injects from baggage-loader */

import get from 'lodash/get'
import parseDate from 'utils/parseDate'
import isNumber from 'lodash/isNumber'
import isString from 'lodash/isString'
import map from 'lodash/map'
import last from 'lodash/last'
import loadTypes from 'utils/loadTypes'
import partial from 'utils/partial'
import sumBy from 'lodash/sumBy'

export const JOURNEYS = loadTypes('JOURNEYS')
export const JOURNEYS_STATS = loadTypes('JOURNEYS_STATS')
export const JOURNEYS_BY_ID = loadTypes('JOURNEYS_BY_ID')
export const JOURNEYS_PER_PAGE = 30
export const JOURNEYS_SET_FILTER = 'JOURNEYS_SET_FILTER'
export const JOURNEYS_SET_SESSION_FILTER = 'JOURNEYS_SET_SESSION_FILTER'
export const JOURNEYS_RESET_FILTERS = 'JOURNEYS_RESET_FILTERS'
export const JOURNEYS_RESET_ALL = 'JOURNEYS_RESET_ALL'
export const JOURNEYS_SET_SESSIONS_ONLY_FILTER = 'JOURNEYS_SET_SESSIONS_ONLY_FILTER'

const initialState = {
  list: [],
  channelStats: [],
  listFetching: false,
  listSkip: 0,
  listTotal: 0,
  sessionsOnly: false,
  filters: {
    countries: [],
    customerType: null,
    orderTime: null,
    productCount: null,
    visitsBeforeOrder: null
  },
  stats: {
    total: 12,
    filtered: 2
  },
  sessions: {
    first: null,
    firstInterval: null,
    firstPercent: 0,
    includes: null,
    includesInterval: null,
    includesPercent: 0,
    last: null,
    lastInterval: null,
    lastPercent: 0,
    singlePercent: 0
  }
}

export default function journeys(state = initialState, action) {
  switch (action.type) {
    case JOURNEYS.REQUEST:
      return {
        ...state,
        listFetching: true
      }
    case JOURNEYS.SUCCESS:
      const {response} = action
      const {aggregations} = response
      return {
        ...state,
        listFetching: false,
        stats: aggrStatsProcessor(action),
        globalStats: aggrGlobalStatsProcessor(action, 'all'),
        sessions: {
          ...state.sessions,
          firstPercent: aggregations['session:first-percent'],
          secondPercent: aggregations['session:include-percent'],
          lastPercent: aggregations['session:last-percent'],
          singlePercent: aggregations['session:single-percent']
        },
        ...listConversionByChannelProcessor(action)
      }
    case JOURNEYS.FAILURE:
      return {
        ...state,
        listFetching: false
      }
    case JOURNEYS_STATS.REQUEST:
      return {
        ...state,
        globalStatsFetching: true
      }
    case JOURNEYS_STATS.SUCCESS:
      return {
        ...state,
        globalStatsFetching: false
        // globalStats: aggrStatsProcessor(action, 'all')
      }
    case JOURNEYS_STATS.FAILURE:
      return {
        ...state,
        globalStatsFetching: false
      }
    case JOURNEYS_SET_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.filterType]: action.filterValue
        }
      }
    case JOURNEYS_SET_SESSION_FILTER:
      console.log("JOURNEYS_SET_SESSION_FILTER")
      return {
        ...state,
        sessions: {
          ...state.sessions,
          [action.filterType]: action.filterValue,
          [action.filterType + 'ChannelTypes']: action.channelTypes
        }
      }

    case JOURNEYS_SET_SESSIONS_ONLY_FILTER:
      return {
        ...state,
        sessionsOnly: action.value
      }

    case JOURNEYS_RESET_FILTERS:
      return {
        ...state,
        filters: initialState.filters,
        sessions: initialState.sessions
      }
    case JOURNEYS_RESET_ALL:
      return {
        ...state,
        filters: initialState.filters,
        sessions: initialState.sessions,
        globalStats: null,
        stats: null
      }
    default:
      return state
  }
}

function listConversionByChannelProcessor(action) {
  const {request, response} = action
  const {channels, channelNodes, channelLinks, countries} = response
  if (!channels) return null
  return {
    listFetching: false,
    listSkip: request.body.skip,
    // listTotal: headers['result-count'],
    list: channels,
    channelNodes,
    channelLinks,
    countries
  }
}

function aggrStatsProcessor(action) {
  const {response} = action
  const {aggregations} = response

  const total = aggregations['order:total']
  const filtered = sumBy(aggregations['productsData'], 'doc_count')
  return {
    ...response.aggregations,
    total,
    filtered
  }
}

function aggrGlobalStatsProcessor(action, name) {
  const {response} = action
  const {aggregations} = response
  const lengthVisit = aggregations.visitsData.length
  let minVisits = 0
  let maxVisits = 0
  if (lengthVisit > 0) {
    minVisits = aggregations.visitsData[0].key
    maxVisits = aggregations.visitsData[lengthVisit - 1].key
  }
  return {
    ...aggregations,
    name,
    minVisits,
    maxVisits
  }
}

export function orderReducer(order) {
  const {sessions, orderItems} = order
  const {value: amount, currency} = order.convertedTotal || order.total || {}
  const info = get(order, 'customer.display', {})
  const parsedAmount = isString(amount) ? parseFloat(amount.replace(',', '.')) : amount

  return {
    id: order.orderId,
    customer: {
      id: order.customerId,
      createdAt: get(order, 'customer.createdAt', null),
      isNew: order.repeat === 'new',
      info: Object.keys(info).length !== 0 ? info : null
    },
    amount: !isNaN(parsedAmount) && isNumber(parsedAmount) ? parsedAmount : null,
    currency,
    new: order.repeat === 'new',
    orderItems: (orderItems || []).map(partial(orderItemsReducer, order.totalOriginalCurrency.currency)),
    touchpoints: (sessions || []).map(sessionReducer),
    date: order.createdAt ? parseDate(order.createdAt) : null
  }
}

function orderItemsReducer(currency, item) {
  const {quantity = 1, name, price} = item

  return {quantity, name, price, currency}
}

function sessionReducer(session, index, sessions) {
  const startedAt = get(session, 'createdAt', null)
  const endedAt = get(session, 'lastRequestAt', null)
  const impressions = get(session, 'impressions', null)

  // const prvSession = index > 0 ? sessions[index - 1] : null
  const parsedImpressions = map(impressions, (value, key) => {
    const info = JSON.parse(key)
    // value = value.filter(item => {
    //   const impressionCreatedAt = JSON.parse(item).createdAt
    //   let isValid = impressionCreatedAt < startedAt
    //   if (prvSession) {
    //     isValid &&= impressionCreatedAt > get(prvSession, 'createdAt', null)
    //   }

    //   return isValid
    // })

    const lastView = value.length ? JSON.parse(last(value)).createdAt : null

    return {
      viewCount: value.length,
      lastView: lastView,
      group: info.group,
      channel: info.channel,
      campaign: info.campaign
    }
  }).filter(impression => {
    return impression.viewCount
  })

  return {
    channel: get(session, 'channel.dv_channel', null),
    channelGroup: get(session, 'channel.dv_chgroup', null),
    virtual: get(session, 'channel.virtual', null),
    device: get(session, 'device', null),
    impressions: parsedImpressions,
    landingPage: get(session, 'landingPage', null),
    startedAt: startedAt ? parseDate(startedAt) : null,
    endedAt: endedAt ? parseDate(endedAt) : null,
    pageviewCount: get(session, 'pageviewCount', null)
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/aggr/index.js